
export const midRightVariants = {
    initial: {
        transform: "scale(1.5) translate3d(50%, 180%, 0) rotate(55deg) "
    }, animate: {
        transform: "scale(1) translate3d(0, 0%, 0) rotate(0deg)",
        transition: {
            duration: 1,
            delay: 0.5,
            ease: [0.16, 1, 0.3, 1]
        }
    }, exit: {
        transform: "scale(1) translate3d(0, 0%, 0) rotate(0deg)",
        ease: [0.7, 0, 0.84, 0], 
        transition: {
            duration: 1
        }
    }
}

export const pageVariants = {
    initial: {
        background: "var(--dark-color)"
    }, animate: {
        background: ["var(--dark-color)", "var(--light-color)"],
        transition: {
            duration: 1,
            ease: "easeIn"
        }
    }, exit: {
        background: "var(--dark-color)",
        transition: {
            delay: 0.75, 
            duration: 0.5,
            ease: "easeInOut"
        }
    }
}

export const horizGridVariants = {
    initial: {
        transform: "scaleX(0)"
    }, animate: (i) => ({
        transform: "scaleX(1)",
        transition: {
            duration: 1 + (0.35*i),
            delay: 0.25,
            ease: [0.16, 1, 0.3, 1]
        }
    }), exit: {
        transform: "scaleX(0)",
        opacity: 0,
        transition: {
            duration: 1,
            ease: "easeIn"
        }
    }
}

export const vertGridVariants = {
    initial: {
        transform: "scaleY(0)"
    }, animate: (i) => ({
        transform: "scaleY(1)",
        transition: {
            duration: 1 + (0.35*i),
            delay: 0.25,
            ease: [0.16, 1, 0.3, 1]
        }
    }), exit: {
        transform: "scaleY(0)",
        opacity: 0,
        transition: {
            duration: 1,
            ease: "easeIn"
        }
    }
}

export const defaultInfoVariants = {
    initial: {
        transform: "translate3d(0, 100%, 0)",
        opacity: 0
    }, animate: (i) => ({
        transform: "translate3d(0, 0%, 0)",
        opacity: 1,
        transition: {
            duration: 1.25,
            delay: 0.25 + 0.05 * i,
            ease: [0.16, 1, 0.3, 1],
            opacity: {
                duration: 0.25,
                ease: "easeIn",
                delay: 0.25 + 0.05 * i,
            }
        }
    }), exit: (i) => ({
        transform: "translate3d(0, 100%, 0)",
        opacity: 0,
        transition: {
            duration: 0.65,
            delay: i * 0.0125,
            ease: [0.7, 0, 0.84, 0]
        }
    })
}

export const tickerSectionVariants = {
    initial: {
        transform: "translate3d(0, 200%, 0) scale3d(1, 2.5, 1)",
        opacity: 0
    }, animate: {
        transform: "translate3d(0, 0%, 0) scale3d(1, 1, 1)",
        opacity: 1,
        transition: {
            duration: 2.5,
            delay: 0.5,
            ease: [.18,1.4,.39,1]
        }
    }, exit: {
        transform: "translate3d(0, 0%, 0) scale3d(0.9, 0.9, 1)",
        opacity: 0,
        transition: {
            duration: 0.75,
            delay: 0,
            ease: [0.55, 0, 1, 0.45]
        }
    }
}

export const rightImgVariants = {
    initial:{
        opacity: 1,
        transform: "translate3d(0, 0,0)"
    }, animate: {
        opacity: 1,
        transform: "translate3d(0, 0,0)"
    }, exit: {
        opacity: 0,
        transform: "translate3d(0, 100%, 0)",
        transition: {
            duration: 1,
            ease: [0.7, 0, 0.84, 0]
        }
    }
}